export const UserColors = {
    XboxGreen: {
        accent: "#008746",
        accentLight1: "#04b358",
        accentLight2: "#1cb069",
        accentLight3: "#32c77f",
        accentDark1: "#0c6b3d",
        accentDark2: "#044e2a",
        accentDark3: "#003019"
    },
    Brown: {
        accent: "#724f2f",
        accentLight1: "#8e7258",
        accentLight2: "#a18a75",
        accentLight3: "#bbaa9b",
        accentDark1: "#644224",
        accentDark2: "#553518",
        accentDark3: "#301d0b"
    },
    Orange: {
        accent: "#eb4910",
        accentLight1: "#ef6d3f",
        accentLight2: "#f18661",
        accentLight3: "#f5a78c",
        accentDark1: "#cb3b10",
        accentDark2: "#ab2d11",
        accentDark3: "#692015"
    },
    Chocolate: {
        accent: "#4c4a4b",
        accentLight1: "#6f6e6f",
        accentLight2: "#888788",
        accentLight3: "#a9a8a8",
        accentDark1: "#424141",
        accentDark2: "#373737",
        accentDark3: "#191919"
    },
    Grey: {
        accent: "#737373",
        accentLight1: "#8f8f8f",
        accentLight2: "#a2a2a2",
        accentLight3: "#bbbbbb",
        accentDark1: "#616161",
        accentDark2: "#4f4f4f",
        accentDark3: "#262626"
    },
    Steel: {
        accent: "#677488",
        accentLight1: "#858f9f",
        accentLight2: "#9aa3b0",
        accentLight3: "#b6bcc5",
        accentDark1: "#536075",
        accentDark2: "#3e4b61",
        accentDark3: "#222b38"
    },
    Taupe: {
        accent: "#7e715c",
        accentLight1: "#978d7c",
        accentLight2: "#a9a193",
        accentLight3: "#c1bab0",
        accentDark1: "#6b5e4a",
        accentDark2: "#574b38",
        accentDark3: "#362f24"
    },
    Olive: {
        accent: "#547a72",
        accentLight1: "#76948e",
        accentLight2: "#8ea7a1",
        accentLight3: "#acbfbb",
        accentDark1: "#3f625a",
        accentDark2: "#294a42",
        accentDark3: "#1c2b28"
    },
    Crimson: {
        accent: "#a21025",
        accentLight1: "#b43f50",
        accentLight2: "#c1616f",
        accentLight3: "#d28c96",
        accentDark1: "#86101e",
        accentDark2: "#691117",
        accentDark3: "#450710"
    },
    Pink: {
        accent: "#ed5588",
        accentLight1: "#f0779f",
        accentLight2: "#f38eb0",
        accentLight3: "#f6adc5",
        accentDark1: "#c63f6c",
        accentDark2: "#9e2950",
        accentDark3: "#57172d"
    },
    Magenta: {
        accent: "#bf1077",
        accentLight1: "#cb3f92",
        accentLight2: "#d461a5",
        accentLight3: "#e08cbd",
        accentDark1: "#99115f",
        accentDark2: "#731247",
        accentDark3: "#4a102e"
    },
    Violet: {
        accent: "#b144c0",
        accentLight1: "#c069cc",
        accentLight2: "#cb83d5",
        accentLight3: "#d9a5e0",
        accentDark1: "#8c2f9a",
        accentDark2: "#671a73",
        accentDark3: "#38163d"
    },
    Indigo: {
        accent: "#744da9",
        accentLight1: "#8f70ba",
        accentLight2: "#a389c6",
        accentLight3: "#bca9d5",
        accentDark1: "#60379a",
        accentDark2: "#4c208a",
        accentDark3: "#24153b"
    },
    Cobalt: {
        accent: "#1073d6",
        accentLight1: "#3f8fde",
        accentLight2: "#61a2e3",
        accentLight3: "#8cbbeb",
        accentDark1: "#1161b0",
        accentDark2: "#134e8a",
        accentDark3: "#133157"
    },
    Navy: {
        accent: "#193e91",
        accentLight1: "#4764a7",
        accentLight2: "#677fb6",
        accentLight3: "#90a2ca",
        accentDark1: "#15357d",
        accentDark2: "#102c69",
        accentDark3: "#101836"
    },
    Cyan: {
        accent: "#1081ca",
        accentLight1: "#3f9ad4",
        accentLight2: "#61abdc",
        accentLight3: "#8cc2e5",
        accentDark1: "#1069a5",
        accentDark2: "#105080",
        accentDark3: "#10314f"
    },
    Turqoise: {
        accent: "#108272",
        accentLight1: "#3f9b8e",
        accentLight2: "#61aca1",
        accentLight3: "#8cc3bb",
        accentDark1: "#0d6659",
        accentDark2: "#0a4f45",
        accentDark3: "#062f29"
    },
    Teal: {
        accent: "#148282",
        accentLight1: "#439b9b",
        accentLight2: "#63acac",
        accentLight3: "#8ec3c3",
        accentDark1: "#146d70",
        accentDark2: "#13585e",
        accentDark3: "#103033"
    },
    Lime: {
        accent: "#54a81b",
        accentLight1: "#76b948",
        accentLight2: "#8ec568",
        accentLight3: "#acd591",
        accentDark1: "#329216",
        accentDark2: "#107c10",
        accentDark3: "#103610"
    },
    Amber: {
        accent: "#eb8c10",
        accentLight1: "#efa33f",
        accentLight2: "#f1b361",
        accentLight3: "#f5c78c",
        accentDark1: "#af6610",
        accentDark2: "#733f10",
        accentDark3: "#4f300e"
    },
    Red: {
        accent: "#e31123",
        accentLight1: "#e8404f",
        accentLight2: "#ec616d",
        accentLight3: "#f18c95",
        accentDark1: "#b4121c",
        accentDark2: "#851414",
        accentDark3: "#471010"
    }
};
//# sourceMappingURL=UserColors.js.map